<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Image({
              label: 'Zdjęcie',
              modelPath: [this, 'form', 'image'],
              required: true
            }),
            new fields.Input({
              label: 'Podpis',
              modelPath: [this, 'form', 'caption'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
